module.exports = __webpack_public_path__ + "static/media/chills.01393659.svg";